enum DealEditTarget {

    StopLoss = "stopLoss",
    TakeProfit = "takeProfit",
}

export default DealEditTarget;
